const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1'])

export function getApiBaseUrl() {
  const configuredBaseUrl = (import.meta.env.VITE_API_BASE_URL || '').trim()

  if (typeof window !== 'undefined') {
    const isLocalHttps =
      window.location.protocol === 'https:' &&
      (LOCAL_HOSTNAMES.has(window.location.hostname) || window.location.hostname.endsWith('.localhost'))

    if (isLocalHttps && configuredBaseUrl.startsWith('http://')) {
      return '/api'
    }
  }

  return configuredBaseUrl
}

export function getApiUrl(path = '') {
  const baseUrl = getApiBaseUrl()
  const safePath = String(path || '')

  if (!safePath) return baseUrl
  if (/^https?:\/\//i.test(safePath)) return safePath
  if (!baseUrl) return safePath.startsWith('/') ? safePath : `/${safePath}`

  return `${baseUrl.replace(/\/+$/, '')}/${safePath.replace(/^\/+/, '')}`
}

export function getFetchErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const message = error?.message || ''

  if (error instanceof TypeError && /failed to fetch|networkerror|load failed/i.test(message)) {
    return 'Unable to reach the RSVP server. Please check your connection and try again.'
  }

  return message || fallback
}

export async function postJSON(path, body) {
  const res = await fetch(getApiUrl(path), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.message || 'Request failed')
  return data
}
